// src/pages/TrilhasPage/TrilhasPage.jsx

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Componentes
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ItemList from '../../components/ItemList/ItemList';
import FriendlyPhrase from '../../components/FriendlyPhrase/FriendlyPhrase';

// Contextos
import { useToast } from '../../contexts/ToastContext';
import { useLoader } from '../../contexts/LoaderContext';
import { useModal } from '../../contexts/ModalContext';

// API
import { useTrilhaService } from '../../services/trilhaServices';

// Estilos
import styles from './trilhaspage.module.css';

function TrilhasPage() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { showModal } = useModal();
  const { showLoader, hideLoader } = useLoader();

  const [trilhas, setTrilhas] = useState([]);

  const { listarTrilhas, deletarTrilha } = useTrilhaService();

  useEffect(() => {
    const carregarTrilhas = async () => {
      showLoader('Carregando trilhas');

      try {
        const response = await listarTrilhas();

        if (response.success) {
          const trilhasMapeadas = (response.data || []).map((trilha) => ({
            id: trilha.id,
            name: trilha.titulo,
          }));
          setTrilhas(trilhasMapeadas);
        } else {
          showToast('Erro ao carregar trilhas', 3000, 'error');
        }
      } catch (err) {
        console.error(err);
        showToast('Erro ao buscar trilhas', 3000, 'error');
      } finally {
        hideLoader();
      }
    };

    carregarTrilhas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEditar = (item) => {
    navigate(`/trilhas/atualizar/${item.id}`);
  };

  const handleExcluir = (item) => {
    showModal(
      `Excluir ${item.name}?`,
      'Essa ação não poderá ser desfeita.',
      async () => {
        showLoader('Excluindo trilha');

        try {
          const response = await deletarTrilha(item.id);

          if (response.success) {
            setTrilhas((prev) => prev.filter((t) => t.id !== item.id));
            showToast('Trilha excluída com sucesso!', 3000, 'success');
          } else {
            showToast(response.message || 'Erro ao excluir trilha', 3000, 'error');
          }
        } catch (error) {
          console.error(error);
          showToast('Erro ao conectar com o servidor', 3000, 'error');
        } finally {
          hideLoader();
        }
      },
      () => {
        showToast('Exclusão cancelada.', 2000);
      }
    );
  };

  const handleAdd = () => {
    navigate('/trilhas/adicionarTrilha');
  };

  const handleSelecionar = (item) => {
    console.log('Trilha selecionada:', item);
    // aqui no futuro dá pra navegar para um "detalhe da trilha" se quiser
    // ex.: navigate(`/trilhas/${item.id}`);
  };

  return (
    <div className={styles.TrilhasPage}>
      <div className={styles.containerTop}>
        <Breadcrumbs />
        <h1 className={styles.title}>Trilhas Cadastradas</h1>
        <FriendlyPhrase page="trilhas" />
      </div>

      <div className={styles.containerList}>
        <ItemList
          items={trilhas}
          onAdd={handleAdd}
          onEdit={handleEditar}
          onDelete={handleExcluir}
          onClickItem={handleSelecionar}
        />
      </div>
    </div>
  );
}

export default TrilhasPage;